const MY_TARGET_ACCOUNT_ID = 3404981;
const MY_TARGET_REACH_GOAL = 'reachGoal';

export const sendMyTargetEvent = (event) => {
  if (window && window._tmr) {
    console.info(
      `[MY_TARGET] ${MY_TARGET_ACCOUNT_ID} -> ${MY_TARGET_REACH_GOAL} -> ${event}`,
    );
    window._tmr.push({
      type: MY_TARGET_REACH_GOAL,
      id: MY_TARGET_ACCOUNT_ID,
      goal: event,
    });
  }
};
